export const getAdjustedCdnUrl = (
  url: string,
  config: {
    bg?: string;
    brightness?: number;
    height?: number;
    quality?: number;
    trim?: boolean;
    width?: number;
  } = {},
) => {
  const {bg, brightness, height, quality, trim, width} = config;
  const updatedUrl = new URL(url);

  if (bg) {
    updatedUrl.searchParams.set('bg', bg);
  }
  if (brightness) {
    updatedUrl.searchParams.set('brightness', brightness.toString());
  }
  if (height) {
    updatedUrl.searchParams.set('height', height.toString());
  }
  if (quality) {
    updatedUrl.searchParams.set('quality', quality.toString());
  }
  if (trim) {
    updatedUrl.searchParams.set('trim', '1');
  }
  if (width) {
    updatedUrl.searchParams.set('width', width.toString());
  }
  return updatedUrl.toString();
};
